"use strict";
/*
 * Created on 19. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var ReleaseAction_1 = require("./ReleaseAction");
/**
 * Request for action with a release.
 *
 * @author Radek Beran
 */


var ReleaseActionRequest =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ReleaseActionRequest, _DomainObject_1$Domai);

  function ReleaseActionRequest(releaseId, action, allCategories, categoryIds) {
    var _this;

    _classCallCheck(this, ReleaseActionRequest);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReleaseActionRequest).call(this));
    _this.releaseId = releaseId;
    _this.action = action;
    _this.allCategories = allCategories;
    _this.categoryIds = categoryIds;
    return _this;
  }

  return ReleaseActionRequest;
}(DomainObject_1.DomainObject);

exports.ReleaseActionRequest = ReleaseActionRequest;

ReleaseActionRequest.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ReleaseActionRequest.name);
  return {
    releaseId: builder.str('releaseId'),
    action: builder.senum('action', ReleaseAction_1.ReleaseAction, 'seq'),
    allCategories: builder.bool('allCategories'),
    categoryIds: builder.listOf(builder.str('categoryIds'))
  };
}();